export default {
  exceptionType: '错误分类',
  exceptionCode: '错误代码',
  productCode: '产品代码',
  quantity: '产品数量',
  sendToAntDate: '发送蚂蚁日期'
}
